import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';

function LoginPage() {
  const { login, error } = useAuth();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' }}>
      <form onSubmit={handleSubmit} style={{ background: 'white', padding: 40, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: 360 }}>
        <h2 style={{ margin: '0 0 24px', textAlign: 'center' }}>Villa Admin Console</h2>
        {error && <div role="alert" aria-live="assertive" style={{ color: '#e74c3c', marginBottom: 16, fontSize: 14 }}>{error}</div>}
        <input type="email" placeholder="Email" aria-label="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          style={{ width: '100%', padding: '10px 12px', marginBottom: 12, border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }} />
        <input type="password" placeholder="Password" aria-label="Password" value={password} onChange={(e) => setPassword(e.target.value)}
          style={{ width: '100%', padding: '10px 12px', marginBottom: 20, border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }} />
        <button type="submit" disabled={loading}
          style={{ width: '100%', padding: '10px 0', background: '#1a73e8', color: 'white', border: 'none', borderRadius: 4, fontSize: 14, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

function AppLayout() {
  const { user, logout } = useAuth();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', height: 56, background: '#1a1a2e', color: 'white', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
          <span style={{ fontWeight: 700, fontSize: 18 }}>Villa Admin</span>
          <nav style={{ display: 'flex', gap: 4 }}>
            <NavLink to="/dashboard" style={({ isActive }) => ({
              padding: '8px 16px', borderRadius: 4, color: 'white', textDecoration: 'none',
              background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent', fontSize: 14,
            })}>Dashboard</NavLink>
            <NavLink to="/products" style={({ isActive }) => ({
              padding: '8px 16px', borderRadius: 4, color: 'white', textDecoration: 'none',
              background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent', fontSize: 14,
            })}>Products</NavLink>
          </nav>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, fontSize: 14 }}>
          <span style={{ opacity: 0.8 }}>{user?.email}</span>
          <button onClick={logout} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', padding: '6px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>
            Sign Out
          </button>
        </div>
      </header>
      <main style={{ flex: 1, overflow: 'hidden' }}>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/products" element={<Products />} />
          <Route path="*" element={<Navigate to="/products" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function AuthGate() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  return isAuthenticated ? <AppLayout /> : <LoginPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AuthGate />
      </BrowserRouter>
    </AuthProvider>
  );
}
